import _get from "lodash/get"
import { store } from "@/store"
import { shipmentCart, setIsPayPalCallback } from "@/store/features/cartSlice"
import { STANDARD } from "@/components/checkout/v2/analytics/constants"

export const assignShipping = (body, cb) => {
  store
    .dispatch(shipmentCart(body))
    .unwrap()
    .then(() => {
      store.dispatch(setIsPayPalCallback(true))
      if (cb) {
        cb()
      }
    })
}

export const getShippingQuantity = parcelItems => {
  let shippingQty = 0

  parcelItems?.map(item => {
    if (item?.isComboSku === false) {
      shippingQty = shippingQty + item?.quantity
    }

    if (item?.isComboSku === true) {
      shippingQty =
        shippingQty +
        item?.childItems.reduce(
          (total, childObj) => total + childObj?.quantity,
          0
        )
    }
  })

  return shippingQty
}

export const shippingMethodData = (lineItems, cartItems) => {
  const parcelMethods = lineItems
    .filter(lineItem => lineItem.type === "Parcel")
    .reduce((acc, { tiers }) => {
      if (acc.length === 0) {
        return [...tiers]
      } else {
        let filteredAcc = acc
        let filteredTiers = tiers
        if (acc.length < tiers.length) {
          filteredTiers = tiers.filter(tier =>
            acc.find(t => t.name === tier.name)
          )
        } else if (acc.length > tiers.length) {
          filteredAcc = acc.filter(tier =>
            tiers.find(t => t.name === tier.name)
          )
        }
        filteredTiers.forEach(tier => {
          const accTier = filteredAcc.find(t => t.name === tier.name)
          if (accTier) {
            accTier.centAmount += tier?.centAmount || 0
          }
        })
        return filteredAcc
      }
    }, [])

  const freightMethods = lineItems
    .filter(lineItem => lineItem.type === "LTL")
    .reduce((acc, { tiers }) => {
      if (acc.length === 0) {
        return [...tiers]
      } else {
        return acc.map(tier => {
          const matchingTier = tiers.find(t => t.name === tier.name)
          if (matchingTier) {
            return {
              ...tier,
              centAmount: tier.centAmount + (matchingTier.centAmount || 0),
            }
          }
          return tier
        })
      }
    }, [])

  const servicetMethods = lineItems
    .filter(lineItem => lineItem.type === "Design Services")
    .reduce((acc, { tiers }) => {
      if (acc.length === 0) {
        return [...tiers]
      } else {
        tiers.forEach(tier => {
          const accTier = acc.find(t => t.name === tier.name)
          if (accTier) {
            accTier.centAmount += tier?.centAmount || 0
          }
        })
        return acc
      }
    }, [])

  const parcelItems = []
  const freightItems = []
  const eDeliveryItems = []

  lineItems
    .filter(lineItem => lineItem.type === "Parcel")
    .map(item => {
      if (item.parentLineItemId) {
        const comboChild = cartItems?.find(prod => prod.id === item.lineItemId)
        if (parcelItems.find(prod => prod.id === item.parentLineItemId)) {
          const comboParent =
            parcelItems.find(prod => prod.id === item.parentLineItemId) || {}
          comboParent.childItems?.push(comboChild)
        } else {
          const comboParent = {
            ...(cartItems?.find(prod => prod.id === item.parentLineItemId) ||
              {}),
          }
          comboParent.childItems = [comboChild]
          parcelItems.push(comboParent)
        }
      } else {
        const cartItem = cartItems?.find(prod => prod.id === item.lineItemId)
        parcelItems.push(cartItem)
      }
    })

  lineItems
    .filter(lineItem => lineItem.type === "LTL")
    .map(item => {
      if (item.parentLineItemId) {
        const comboChild = cartItems?.find(prod => prod.id === item.lineItemId)
        if (freightItems.find(prod => prod.id === item.parentLineItemId)) {
          const comboParent =
            freightItems.find(prod => prod.id === item.parentLineItemId) || {}
          comboParent.childItems?.push(comboChild)
        } else {
          const comboParent = {
            ...(cartItems?.find(prod => prod.id === item.parentLineItemId) ||
              {}),
          }
          comboParent.childItems = [comboChild]
          freightItems.push(comboParent)
        }
      } else {
        const cartItem = cartItems?.find(prod => prod.id === item.lineItemId)
        freightItems.push(cartItem)
      }
    })

  lineItems
    .filter(lineItem => lineItem.type === "Design Services")
    .map(item => {
      if (item) {
        const cartItem = cartItems?.find(prod => prod.id === item.lineItemId)
        eDeliveryItems.push(cartItem)
      }
    })

  return {
    freightMethods,
    parcelMethods,
    servicetMethods,
    parcelItems,
    freightItems,
    eDeliveryItems,
  }
}

export const getPromoTotalAmount = (codes, name) => {
  let total = 0
  codes.forEach(e => {
    if (e.name === name) {
      total += Number(e.discount)
    }
  })
  return total
}

export const serviceAmount = (services, selected) => {
  const serviceAmount = Number(services[selected?.service]?.centAmount / 100)
  return serviceAmount
}

export const getFreightsAmount = data => {
  const {
    freights,
    selected,
    currencySign,
    promoCodes,
    freightName,
    freeShipping,
  } = data
  const totalPromo = getPromoTotalAmount(promoCodes, freightName)
  const freightAmount =
    Number(freights[selected?.freight]?.centAmount / 100) - totalPromo
  const shippingCost = freightAmount
    ? `${currencySign}${freightAmount.toFixed(2)}`
    : freeShipping
  return shippingCost
}

export const getParcelsAmount = data => {
  const {
    currencySign,
    parcels,
    selected,
    promoCodes,
    parcelName,
    freeShipping,
  } = data
  const totalPromo = getPromoTotalAmount(promoCodes, parcelName)
  const parcelsAmount =
    Number(parcels[selected?.parcel]?.centAmount / 100) - totalPromo

  const shippingCost = parcelsAmount
    ? `${currencySign}${parcelsAmount.toFixed(2)}`
    : freeShipping
  return shippingCost
}

export const optionAmount = option => {
  const optionAmount = Number(option.centAmount / 100)
  return optionAmount
}

export const discountMethod = cart => {
  cart?.lineItems
    ?.filter(item => !item.custom?.fields?.bundleParentId)
    .forEach(item => {
      let discountPercentage = 0
      if (item.price?.discounted)
        discountPercentage =
          Number(
            _get(item.price.discounted, "discount.obj.value.permyriad", 0)
          ) / 100
      if (item.discountedPrice)
        discountPercentage =
          Number(
            _get(
              item.discountedPrice,
              "includedDiscounts[0].discount.obj.value.permyriad",
              0
            )
          ) / 100
      return discountPercentage
    })
}

export const getDeliveryOption = selected => {
  let deliveryOption
  if (selected?.parcel === 1) {
    deliveryOption = "express"
  } else if (selected?.parcel === 2) {
    deliveryOption = "premium"
  } else {
    deliveryOption = "standard"
  }

  return deliveryOption
}

export const preventBodyScrollPayError = status => {
  if (status) {
    document.body.classList.add("scroll-lock-payError", "modal-open")
    document
      .getElementsByTagName("html")[0]
      .classList.add("scroll-lock-payError", "modal-open")
  } else {
    document.body.classList.remove("scroll-lock-payError", "modal-open")
    document
      .getElementsByTagName("html")[0]
      .classList.remove("scroll-lock-payError", "modal-open")
  }
}

export const findSelectParcelType = (selected = {}, parcels = []) => {
  let parcelTypeName = STANDARD
  const { parcel = 0 } = selected
  if (parcels[parcel]) {
    parcelTypeName = parcels[parcel].name
  }
  return parcelTypeName?.toLocaleLowerCase()
}
